export default {
  'purchaseOrder.home': '首页',
  'purchaseOrder.login': '登录',
  'purchaseOrder.register': '注册',
  'purchaseOrder.register.result': '注册结果',
  'purchaseOrder.dashboard': 'Dashboard',
  'purchaseOrder.dashboard.analysis': '分析页',
};
